<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage">
<a id="title45"></a>
<div class="p"><span><em class="i">To my mother, Maxine Conant, for teaching me to love words. To my dad, Nelson Valdés, for giving me the guts to put them on paper. To Patrick, the babydaddy, for giving me time to write. To K. C. Porter, for music. To J. N., for the inside celebrity scoop. And to Alexander Patrick Rodriguez, for continuing to be the best minuscule muse a mommy could ask for.</em></span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429919197_ded01.vue?b2b50fd6